import React from "react";

import "../../../styles/forms.scss";
import { useTranslation } from "react-i18next";

export default function NationalityPersonalInformationPreview({
  nationality,
  isForeingWithOutDoc,
  index
}) {
  let { t } = useTranslation();
  const isFirstField = index === 0;
  return (
    <div className="nationality">
      <div className="form-group">
        <div className="label-wrapper">
          {isFirstField && (
            <label htmlFor="personalDetailLabelNationality">
              {t("Nationality*")}
            </label>
          )}
        </div>
        <select
          className="form-select"
          id="nationalityId"
          name="nationalityId"
          style={{ width: "100%", minWidth: "340px" }}
          disabled
        >
          <option>{nationality}</option>
        </select>
      </div>
      {index === 0 && (
        <div className="needs-documentation">
          <label className="form-check-label" htmlFor="flexSwitchCheckDefault">
            {t("Need Documentation?")}
          </label>
          <div className="form-check form-switch">
            <input
              className="form-check-input"
              type="checkbox"
              id="isForeingWithOutDoc"
              name="isForeingWithOutDoc"
              checked={isForeingWithOutDoc}
              disabled
            />
          </div>
        </div>
      )}
    </div>
  );
}
